import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Box, Center, Container, Flex, Text } from '@mantine/core';
import { Loading, Title } from '../../../../component';
import { useWindowSize } from '../../../../hooks';
import { TaskStepper } from './TaskStepper';
import { useWaitingStateStore } from '../../../../store';
import { useParticipantDataStore } from '../../../../store/ParticipantDataStore';
import getStepperActionButton from './getStepperActionButton';
import { Header } from '../../../public/navigation';
import { useTranslation } from 'react-i18next';
import { AffiliateCode } from './AffiliateCode';
import { WaitingScreenVouchers } from './WaitingScreenVouchers';
import { BmsReminderBanner } from './BmsReminderBanner';
import { BagSurveyBanner } from './BagSurveyBanner';
import { NachversandBanner } from './NachversandBanner';

export const WaitingState = observer(() => {
  const waitingStateStore = useWaitingStateStore();
  const participantDataStore = useParticipantDataStore();
  const isLoading = waitingStateStore.loadingAccessState;
  const {
    currentStepKey,
    baseLineSurveyLink,
    loadingBaselineState,
    bdmState,
    isBdm1SurveyDue,
  } = waitingStateStore;
  const isSmallScreen = useWindowSize(600);
  const { t } = useTranslation('waiting-screen');

  useEffect(() => {
    participantDataStore.getBagSurveyStatus();
  }, [participantDataStore]);

  if (isLoading) return <Loading />;

  return (
    <>
      <Header canLogout />
      <Flex p="40px 20px 0px 20px" gap="30px" justify="center" align="center">
        <Flex w="1000px" justify="space-between" wrap="wrap">
          <Box>
            <Title text={t('Title')} boxPadding="0px" textPadding="0px" />
            <Text maw="600px" m="10px 0px 0px 0px">
              {t('Description')}
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Container fluid p={0}>
        <Center p={isSmallScreen ? '20px 0px' : '20px'}>
          <Flex direction="column">
            <Box
              maw="1000px"
              bg="#fff"
              p="10px 20px"
              my="20px"
              style={{ borderRadius: isSmallScreen ? 0 : 8 }}
            >
              <AffiliateCode />
            </Box>
            <Flex
              direction="column"
              bg="#fff"
              maw="1000px"
              style={{ borderRadius: isSmallScreen ? 0 : 5 }}
            >
              <WaitingScreenVouchers />
              <BmsReminderBanner />
              <BagSurveyBanner />
              <NachversandBanner />
              <Flex m={15} direction="column" p="10px">
                <Text fw="700" size="21px">
                  {t('YourCurrentTask')}
                </Text>

                <TaskStepper
                  currentAction={getStepperActionButton(
                    currentStepKey,
                    baseLineSurveyLink,
                    loadingBaselineState,
                    bdmState,
                    isBdm1SurveyDue,
                  )}
                />
              </Flex>
            </Flex>
          </Flex>
        </Center>
      </Container>
    </>
  );
});
